import Errorboundary from "../Components/ErrorBoundary";
import { authRouter } from "./AuthRouter";
import { AuthPrivateRoute, DashboardPrivateRoute } from "./PrivateRouter";
import { dashboardRouter } from "./DashboardRouter";

export const routing = [
  {
    element: <AuthPrivateRoute />,
    children: [authRouter],
    errorElement: <Errorboundary />,
  },
  {
    element: <DashboardPrivateRoute />,
    children: [dashboardRouter],
    errorElement: <Errorboundary />,
  },
];
